import React, { forwardRef, Ref } from 'react';
import styled from '@emotion/styled';
import MUIFab, {
  FabProps as MUIFabProperties,
} from '@mui/material/Fab';
import breakpoints from '../Theme/breakpoints';

const Fab = forwardRef((properties: MUIFabProperties & {
  target: string | null;
  rel: string | null;
  component?: string;
}, reference: Ref<HTMLButtonElement>) => (
  <MUIFab {...properties} ref={reference} />
));

const FloatingButton = styled(Fab)`
  && {
    display: flex;
    position: fixed;
    box-shadow: 
    0px 3px 5px -1px rgb(0 0 0 / 20%),
    0px 6px 10px 0px rgb(0 0 0 / 14%),
    0px 1px 18px 0px rgb(0 0 0 / 12%);
    bottom: 8px;
    z-index: 2;
    line-height: 3.1;
    left: 5%;
    right: 5%;

    @media (min-width: ${breakpoints.xssm}px) {
      left: 15%;
      right: 15%;
    }

    @media (min-width: ${breakpoints.sm}px) {
      left: 25%;
      right: 25%;
    }

    @media (min-width: ${breakpoints.md}px) {
      left: 35%;
      right: 35%;
    }

    @media (min-width: ${breakpoints.lg}px) {
      display: flex;
      position: static;
      margin: 24px auto;
      text-align: center;
      width: fit-content;
    }
  }
  a {
    color: var(--white);
  }
`;

export default FloatingButton;
